import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PlanningFulfillmentFiltersComponent implements IController {
  filters: any;
  enableDates?: boolean;
  onChangeFilters: Function;


  public isLocationSectionExpanded: boolean = false;
  public isTimeSectionExpanded: boolean = false;
  public isExecutionSectionExpanded: boolean = false;
  public isOrderInformationSectionExpanded: boolean = false;

  constructor() {
  }

  onChange(values, type){
    this.filters[type] = values;
    this.onChangeFilters({filters: this.filters});
  }

  onChangeTagNames(tagNames, isExcludeMode) {
    if (isExcludeMode) {
      _.set(this.filters, 'excludedTags', tagNames);
      _.unset(this.filters, 'tags');
    } else {
      _.set(this.filters, 'tags', tagNames);
      _.unset(this.filters, 'excludedTags');
    }
    this.onChangeFilters({filters: this.filters});
  }

  onChangeFilterBy(value){
    this.filters.filterByCreatedAt = value;
    this.onChangeFilters({filters: this.filters});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningFulfillmentFilters', {
    bindings: {
      filters: '<',
      enableDates: '<?',
      onChangeFilters: '&'
    },
    template: require('./planning-fulfillment-filters.html').default,
    controller: PlanningFulfillmentFiltersComponent
  });

